"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.signOperation = void 0;
var tx_1 = require("@ethereumjs/tx");
var eip55_1 = __importDefault(require("eip55"));
var rlp_1 = require("rlp");
var invariant_1 = __importDefault(require("invariant"));
var logs_1 = require("@ledgerhq/logs");
var hw_app_eth_1 = __importDefault(require("@ledgerhq/hw-app-eth"));
var bignumber_js_1 = require("bignumber.js");
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var errors_1 = require("@ledgerhq/errors");
var erc20_1 = require("@ledgerhq/hw-app-eth/erc20");
var hw_app_eth_2 = require("@ledgerhq/hw-app-eth");
var erc20_2 = require("./modules/erc20");
var Ethereum_1 = require("../../api/Ethereum");
var deviceAccess_1 = require("../../hw/deviceAccess");
var nft_1 = require("../../nft");
var env_1 = require("../../env");
var modules_1 = require("./modules");
var transaction_1 = require("./transaction");
var logic_1 = require("./logic");
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, rxjs_1.from)(transaction.nonce !== undefined
        ? (0, rxjs_1.of)(transaction.nonce)
        : (0, Ethereum_1.apiForCurrency)(account.currency).getAccountNonce(account.freshAddress)).pipe((0, operators_1.mergeMap)(function (nonce) {
        return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
            return new rxjs_1.Observable(function (o) {
                var cancelled;
                function main() {
                    var _a;
                    return __awaiter(this, void 0, void 0, function () {
                        var freshAddressPath, freshAddress, gasPrice, maxFeePerGas, maxPriorityFeePerGas, gasLimit, dataMissing, missingDataString, _b, ethTxObject, tx, common, fillTransactionDataResult, to, value, txHex, loadConfig, m, resolutionConfig, resolution, eth, addrs, erc20SignatureBlob, addrs_1, addrs_1_1, addr, tokenInfo, e_1_1, result, v, r, s, signedTx, signature, txHash, senders, recipients, fee, transactionSequenceNumber, accountId, operation;
                        var e_1, _c;
                        return __generator(this, function (_d) {
                            switch (_d.label) {
                                case 0:
                                    freshAddressPath = account.freshAddressPath, freshAddress = account.freshAddress;
                                    gasPrice = transaction.gasPrice, maxFeePerGas = transaction.maxFeePerGas, maxPriorityFeePerGas = transaction.maxPriorityFeePerGas;
                                    gasLimit = (0, transaction_1.getGasLimit)(transaction);
                                    dataMissing = !new bignumber_js_1.BigNumber(gasLimit).gt(0);
                                    missingDataString = "";
                                    if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
                                        missingDataString = " maxFeePerGas=".concat(String(maxFeePerGas), " maxPriorityFeePerGas=").concat(String(maxPriorityFeePerGas));
                                        dataMissing =
                                            dataMissing && (!maxFeePerGas || !maxPriorityFeePerGas);
                                    }
                                    else {
                                        missingDataString = " gasPrice=".concat(String(gasPrice));
                                        dataMissing = dataMissing && !gasPrice;
                                    }
                                    if (dataMissing) {
                                        (0, logs_1.log)("ethereum-error", "buildTransaction missingData: ".concat(missingDataString, " gasLimit=").concat(String(gasLimit)));
                                        throw new errors_1.FeeNotLoaded();
                                    }
                                    _b = (0, transaction_1.buildEthereumTx)(account, transaction, nonce), ethTxObject = _b.ethTxObject, tx = _b.tx, common = _b.common, fillTransactionDataResult = _b.fillTransactionDataResult;
                                    to = eip55_1["default"].encode((tx.to || "").toString());
                                    value = new bignumber_js_1.BigNumber("0x" + (tx.value.toString("hex") || "0"));
                                    txHex = (function () {
                                        if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
                                            return tx.getMessageToSign(false).toString("hex");
                                        }
                                        var rawData = tx.raw();
                                        rawData[6] = Buffer.from((0, logic_1.padHexString)(common.chainIdBN().toString("hex")), "hex");
                                        return Buffer.from((0, rlp_1.encode)(rawData)).toString("hex");
                                    })();
                                    loadConfig = {
                                        cryptoassetsBaseURL: (0, env_1.getEnv)("DYNAMIC_CAL_BASE_URL")
                                    };
                                    if ((0, nft_1.isNFTActive)(account.currency)) {
                                        loadConfig.nftExplorerBaseURL =
                                            (0, env_1.getEnv)("NFT_ETH_METADATA_SERVICE") + "/v1/ethereum";
                                    }
                                    m = modules_1.modes[transaction.mode];
                                    (0, invariant_1["default"])(m, "missing module for mode=" + transaction.mode);
                                    resolutionConfig = m.getResolutionConfig
                                        ? m.getResolutionConfig(account, transaction)
                                        : {};
                                    (0, logs_1.log)("rawtx", txHex);
                                    return [4 /*yield*/, hw_app_eth_2.ledgerService.resolveTransaction(txHex, loadConfig, resolutionConfig)];
                                case 1:
                                    resolution = _d.sent();
                                    eth = new hw_app_eth_1["default"](transport);
                                    eth.setLoadConfig(loadConfig);
                                    addrs = (fillTransactionDataResult &&
                                        fillTransactionDataResult.erc20contracts) ||
                                        [];
                                    return [4 /*yield*/, (0, erc20_2.erc20SignatureInfo)(loadConfig)];
                                case 2:
                                    erc20SignatureBlob = _d.sent();
                                    _d.label = 3;
                                case 3:
                                    _d.trys.push([3, 8, 9, 10]);
                                    addrs_1 = __values(addrs), addrs_1_1 = addrs_1.next();
                                    _d.label = 4;
                                case 4:
                                    if (!!addrs_1_1.done) return [3 /*break*/, 7];
                                    addr = addrs_1_1.value;
                                    tokenInfo = (0, erc20_1.byContractAddressAndChainId)(addr, ((_a = account.currency.ethereumLikeInfo) === null || _a === void 0 ? void 0 : _a.chainId) || 0, erc20SignatureBlob);
                                    if (!tokenInfo) return [3 /*break*/, 6];
                                    return [4 /*yield*/, eth.provideERC20TokenInformation(tokenInfo)];
                                case 5:
                                    _d.sent();
                                    if (cancelled)
                                        return [2 /*return*/];
                                    _d.label = 6;
                                case 6:
                                    addrs_1_1 = addrs_1.next();
                                    return [3 /*break*/, 4];
                                case 7: return [3 /*break*/, 10];
                                case 8:
                                    e_1_1 = _d.sent();
                                    e_1 = { error: e_1_1 };
                                    return [3 /*break*/, 10];
                                case 9:
                                    try {
                                        if (addrs_1_1 && !addrs_1_1.done && (_c = addrs_1["return"])) _c.call(addrs_1);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                    return [7 /*endfinally*/];
                                case 10:
                                    o.next({ type: "device-signature-requested" });
                                    return [4 /*yield*/, eth.signTransaction(freshAddressPath, txHex, resolution)];
                                case 11:
                                    result = _d.sent();
                                    if (cancelled)
                                        return [2 /*return*/];
                                    o.next({ type: "device-signature-granted" });
                                    v = "0x".concat(result.v);
                                    r = "0x".concat(result.r);
                                    s = "0x".concat(result.s);
                                    signedTx = (function () {
                                        if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
                                            return new tx_1.FeeMarketEIP1559Transaction(__assign(__assign({}, ethTxObject), { v: v, r: r, s: s }), { common: common });
                                        }
                                        return new tx_1.Transaction(__assign(__assign({}, ethTxObject), { v: v, r: r, s: s }), { common: common });
                                    })();
                                    signature = "0x".concat(signedTx.serialize().toString("hex"));
                                    txHash = "";
                                    senders = [freshAddress];
                                    recipients = [to];
                                    fee = (function () {
                                        if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
                                            return maxFeePerGas
                                                .plus(maxPriorityFeePerGas)
                                                .times(gasLimit);
                                        }
                                        return gasPrice.times(gasLimit);
                                    })();
                                    transactionSequenceNumber = nonce;
                                    accountId = account.id;
                                    operation = {
                                        id: "".concat(accountId, "-").concat(txHash, "-OUT"),
                                        hash: txHash,
                                        transactionSequenceNumber: transactionSequenceNumber,
                                        type: "OUT",
                                        value: new bignumber_js_1.BigNumber(value),
                                        fee: fee,
                                        blockHash: null,
                                        blockHeight: null,
                                        senders: senders,
                                        recipients: recipients,
                                        accountId: accountId,
                                        date: new Date(),
                                        extra: {},
                                        transactionRaw: (0, transaction_1.toTransactionRaw)(transaction)
                                    };
                                    m.fillOptimisticOperation(account, transaction, operation);
                                    o.next({
                                        type: "signed",
                                        signedOperation: {
                                            operation: operation,
                                            signature: signature,
                                            expirationDate: null
                                        }
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    });
                }
                main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
                return function () {
                    cancelled = true;
                };
            });
        });
    }));
};
exports.signOperation = signOperation;
//# sourceMappingURL=signOperation.js.map